/* eslint-disable jira/filename-case */
import type { JiraUserBoardNavigationData } from '@jira/navigation-apps__resources/src/services/sidebar/jsw-userboard-sidebar-navigation/types.tsx';
import type { JiraSoftwareNavData } from '@jira/navigation-apps__resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import type { Board } from '../../../types.tsx';

export const extractData = (jiraSoftwareNavData: JiraSoftwareNavData): Board | null => {
	if (jiraSoftwareNavData.boardInfo == null) {
		return null;
	}
	const {
		boardInfo: { id, type = 'scrum', name },
	} = jiraSoftwareNavData;

	return {
		id,
		type,
		name,
		isProjectBoard: true,
	};
};

export const extractUserBoard = (userBoardNavData: JiraUserBoardNavigationData): Board | null => {
	const {
		boardInfo: { id, type = 'scrum', name },
	} = userBoardNavData;

	return {
		id,
		type,
		name,
		isProjectBoard: false,
	};
};
